// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"446":"fd720bd8","460":"fb932846"}[chunkId] + ".chunk.css";
};